import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode"
import { EntityEnum } from "../../EntityEnum";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { AttachmentEntityListView } from "../../../Data/MedicinalProductData/AttachmentEntityListView";
import { AttachmentAutoUploadEntity } from "../Entity/AttachmentAutoUploadEntity";
import { BaseNode } from "../../BaseNode";


export class TreeNodeMedicinalProductsAttachment extends SimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new AttachmentEntityListView(items), 'Attachments', useHist ? EntityEnum.attachmentHist : EntityEnum.attachment);
        this.useHist = useHist;
    }

    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${this.ioc!.get(LookupGetService).retrieveValueFromCache('language', model.languagecode)} - ${model.ev_Code} - ${model.attachmentname}`;
        return this.addChildNode(AttachmentAutoUploadEntity,labelTemplate, this,model, this.useHist, false, false);
        // add specific nodes for this entity

    }
    override getCriteriaFields(): string[] {
        return ['ev_Code', 'attachmentname'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for attachments records owned in the XEVMPD by your HQ";
    }
}